import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import {Taxon} from "../Entity/Taxon";


export async function getTaxonsRep(locale:string, taxonomyParent?:string): Promise<Taxon> {
  try {
    const response = await axios.get<Taxon>(
      `${BASE_API_URL}/taxon_children?locale=${locale}` + (taxonomyParent ? `&translatable.parent.code=${taxonomyParent}` : ""),
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }

}
